$(function(){
	$(document).on('click', '.cplqs_minus, .cplqs_plus', function(e){
		e.preventDefault();
		var t = $(this);
		var isQtdReadOnly = t.closest('.cpl_quantityselect').hasClass('qtdreadonly_true');
		
		
		if(!isQtdReadOnly){
			var product = t.closest('.cartproduct');
			var action = t.attr('data-action');
			var input = t.closest('.cpl_quantityselect').find('.cplqs_value input');
			var value = Number(input.val());
	
			var id_product = Number(product.attr('data-id_product'));
			var id_producttype = Number(product.attr('data-id_producttype'));
			var id_variant = product.attr('data-id_variant');
			var qty = 1;
	console.log( action );
			if(action=='less'){
				if(value>0){
					value--;
					service_DeleteFromCart(id_product, id_producttype, id_variant, qty, t);
				}
			} else {
				value++;
				service_AddToCart(id_product, id_producttype, id_variant, qty, t);
			}
			input.val(value);
		}
		
	});
	



	




	$(document).on('change', '.shipbillingaddresscheck input', function(){

        /*
		var t = $(this);
		var state = t.prop('checked');
		if(state==false){
			var baHeight = $('.billing_address_inner').height();
			$('.billing_address').stop().animate({
				height: baHeight
			});
		} else {
			$('.billing_address').stop().animate({
				height: 0
			});
		}*/

        $('.billing_address_inner').toggle('display'); //PBS: 12 lines to 1

	});

});





//PBS: do this only after validation
/*
$(function(){
	$(document).on('click', '#checkout-open-modal', function(){
		var products = $('.coos_original').clone();
		products.removeClass('coos_original');
		products.find('.checkout_ordersummary').removeAttr('style');
		$('.coconfirm_productlist').empty();
		$('.coconfirm_productlist').append(products);
	});

	$(document).on('click', '.swe_errormessage_goback', function(e){
		e.preventDefault();
		$('.submitwindow_error').fadeOut();
		$('.submitwindow').fadeOut();
	});
});
*/

$(function(){
	$(document).on('click', '.btn_getquote', function(e){
		e.preventDefault();
		$('.quotelist_wrapper').empty();
		var t = $(this);
		var wrapper = t.closest('.calculateshipping_wrapper');
		var ship_country = wrapper.find('.country_wrapper select').val();
		var ship_state =  wrapper.find('.state_wraper select').val();
		var ship_zipcode = wrapper.find('.zipcode_wraper input').val();
		
		$.ajax({
			url: sUrlShop+'/api/v1/shop/carts/shipping_methods'+Cookies.get('token')+'?ship_country='+ship_country+'&ship_state='+ship_state+'&ship_zipcode='+ship_zipcode,
			method: 'GET',
xhrFields: {
                withCredentials: true
            },
                crossDomain: true,
			context: document.body
		}).done(function(data) {			
			for(var key in data){
				var item = data[key];
				
				var id_shipping_method = item.id_shipping_method;
				var name = item.name;
				var price = item.price;
				var selected = item.selected;
				
				if(selected!=undefined&&selected=='true'){
					selected = 'checked';
				} else {
					selected = '';
				}
				
				
				$('.quotelist_wrapper').append('																	\
					<div class="col-xs-12">																			\
						<label>																						\
							<input type="radio" '+selected+' name="quoteoption" value="'+id_shipping_method+'">		\
							'+name+'																				\
						</label>																					\
					</div>																							\
				');
			}
		});
	});
	
	
	
	$(document).on('click', '.btn-applyshipping', function(e){
		e.preventDefault();
		
		var wrapper = $('.calculateshipping_wrapper');
		var ship_country = wrapper.find('.country_wrapper select').val();
		var ship_state =  wrapper.find('.state_wraper select').val();
		var ship_zipcode = wrapper.find('.zipcode_wraper input').val();
		var id_shipping_method = $('#getquote_modal .quotelist_wrapper input:checked').val();	
		
		var json = {
			id_shipping_method: ''+id_shipping_method+'',
			ship_country: ''+ship_country+'',
			ship_state: ''+ship_state+'',
			ship_zipcode: ''+ship_zipcode+''
		}
		$.ajax({
			url: sUrlShop+'/api/v1/shop/carts/shipping_methods'+Cookies.get('token'),
			method: 'POST',
			data: JSON.stringify(json),
			contentType: 'application/json',
			dataType: 'json',
			xhrFields: {
		        withCredentials: true
		    },
			crossDomain: true,
			context: document.body
		}).done(function(data) {

			//console.log('was getting cart data');
			service_GetCart( 'step-01' );

		});		
	});

});




/*
 *	Add Promo Code
 */
$(document).on('click', '.btn_apply', function(e){
	e.preventDefault();
	var t = $(this);
	var code = t.closest('.cci_promo').find('.ccip_code').val();
	if(code!=''){
		var json = [ 
			{
				promocode: ''+code+'',
				type: 'promocode'
			}
		];
		$.ajax({
			url: sUrlShop+'/api/v1/shop/carts',
			method: 'POST',
			data: JSON.stringify(json),
			contentType: 'application/json',
			dataType: 'json',
			xhrFields: {
		        withCredentials: true
		    },
			crossDomain: true,
			context: document.body
		}).done(function(data) {
			service_GetCart();
		}).error(function(data) {
			$('.cci_insertedpromocodes').append('<div class="div_promocode alert">'+data.responseJSON.message+'</div>');
			setTimeout(function(){ $(".cci_insertedpromocodes .div_promocode.alert").stop().fadeOut("slow");  }, 3000);
			setTimeout(function(){ $(".cci_insertedpromocodes .div_promocode.alert").remove(); }, 5000);
		});
	}
});
/*
* end Add Promo Code
*/

/*
 *	Remove Promo Code
 */
$(document).on('click', '.cpl_deletepromocode', function(e){
	e.preventDefault();
	var t = $(this);
	var div = t.closest(".div_promocode");
	var promocode_name = div.find('.promocode_name').text();
	var promocode_description = div.find('.promocode_description').text();
	if(promocode_name!=''){
		var json = [ 
			{
				name: promocode_name,
				description: promocode_description,
				type: 'promocode',
				token: Cookies.get('token').replace('/','')
			}
		];
		$.ajax({
			url: sUrlShop+'/api/v1/shop/carts'+Cookies.get('token'),
			method: 'DELETE',
			data: JSON.stringify(json),
			contentType: 'application/json',
			dataType: 'json',
			xhrFields: {
		        withCredentials: true
		    },
			crossDomain: true,
			context: document.body
		}).done(function(data) {
			service_GetCart();
		});
	}
});
/*
 *	end Remove Promo Code
 */













